import { render, staticRenderFns } from "./input-placeholder.vue?vue&type=template&id=82830e74&scoped=true"
import script from "./input-placeholder.vue?vue&type=script&lang=js"
export * from "./input-placeholder.vue?vue&type=script&lang=js"
import style0 from "./input-placeholder.vue?vue&type=style&index=0&id=82830e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82830e74",
  null
  
)

export default component.exports